import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "./api";

const ist = (d) => new Date(d.getTime() + 330 * 60000).toISOString().slice(0, 10);
export const todayIst = () => ist(new Date());
export const daysAgo = (n) => ist(new Date(Date.now() - n * 86400e3));

export const RANGES = [["Today", 0], ["7D", 7], ["30D", 30], ["90D", 90], ["1Y", 365]];

export function useReport(path, params) {
  const [state, setState] = useState({ data: null, error: null, loading: true, path });
  const sig = JSON.stringify(params);
  useEffect(() => {
    let live = true;
    setState((s) => (s.path === path ? { ...s, loading: true } : { data: null, error: null, loading: true, path }));
    api.get(path, { params: JSON.parse(sig) })
      .then((r) => live && setState({ data: r.data, error: null, loading: false, path }))
      .catch((e) => live && setState({ data: null, error: errMsg(e), loading: false, path }));
    return () => { live = false; };
  }, [path, sig]);
  // never hand one report's payload to another report's view (tab switch before the new fetch resolves)
  return state.path === path ? state : { data: null, error: null, loading: true, path };
}

export async function downloadCsv(path, params) {
  try {
    const r = await api.get(path, { params: { ...params, format: "csv" }, responseType: "blob" });
    const name = (r.headers["content-disposition"] || "").match(/filename="(.+)"/)?.[1] || "report.csv";
    const url = URL.createObjectURL(r.data);
    const a = Object.assign(document.createElement("a"), { href: url, download: name });
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
    toast.success(`Downloaded ${name}`, { description: "SIMULATED – not a real trade record" });
  } catch (e) {
    let msg = errMsg(e);
    if (e?.response?.data instanceof Blob) { try { msg = JSON.parse(await e.response.data.text()).detail || msg; } catch (x) { /* keep */ } }
    toast.error(msg);
  }
}
